// Enterprise Tour constants
export const TOUR_STATE_KEY = "enterprise_tour_state";
export const TOUR_COMPLETED_KEY = "enterprise_tour_completed";

export const TOUR_TIMING = {
  STEP_TRANSITION_MS: 300,
  CUT_SCENE_DURATION_MS: 3000,
  NAVIGATION_SETTLE_MS: 1500,
  // Was 500ms - was layered on top of waitFor polls and tour next() setTimeout,
  // adding ~1.1s to every step advance. 200ms is enough for browser scroll to
  // finish before the spotlight overlay redraws.
  SCROLL_SETTLE_MS: 200,
  ELEMENT_WAIT_TIMEOUT_MS: 5000,
  MATCH_SCORE_ANIMATION_MS: 2000,
};

export const TOUR_SECTIONS = {
  THE_FEED: 0,
  BUYER_AGENT_CUTSCENE: 1,
  MY_WANT_LISTINGS_NAV: 2,
  MY_WANT_LISTINGS_DASHBOARD: 3,
  WANT_LISTING_WALKTHROUGH: 4,
  WANT_LISTING_MATCHES: 5,
  SELLER_AGENT_CUTSCENE: 6,
  MY_INVENTORY_NAV: 7,
  MY_INVENTORY_DASHBOARD: 8,
  INVENTORY_MATCHES: 9,
  REPORTING: 10,
  COLLABORATION_CUTSCENE: 11,
  BROWSE_FEED: 12,
  AGENT_COMMUNICATION: 13,
  THANK_YOU: 14,
};

export const SECTION_LABELS = [
  "The Feed",
  "Buyer Agent",
  "Want-Listings",
  "Dashboard",
  "Walkthrough",
  "Matches",
  "Seller Agent",
  "Inventory",
  "Demand Data",
  "Inventory Matches",
  "Reporting",
  "Collaboration",
  "Browse",
  "Communication",
  "Thank You",
];
